import { FC } from 'react'
import { InsiPatientFirstnameChangeValidationModalProps } from './InsiPatientFirstnameChangeValidationModal.model'
import { ValidationModal } from '../../../../shared/modal/ValidationModal/ValidationModal.component'
import styles from './InsiPatientFirstnameChangeValidationModal.module.scss'

export const InsiPatientFirstnameChangeValidationModal: FC<
  InsiPatientFirstnameChangeValidationModalProps
> = ({ insiResponseFirstname, userInputFirstname, isUnmounting, onSubmit, onClose }) => {
  return (
    <ValidationModal
      isUnmounting={isUnmounting}
      onClose={onClose}
      cancelLabel="Ignorer"
      onSubmit={onSubmit}
      confirmLabel="Modifier"
      size="medium"
      title="Différence sur le premier prénom de naissance"
      icon="infoCircle"
      description="Le téléservice INSi a fourni un premier prénom de naissance différent de celui présent dans le formulaire. Souhaitez-vous utiliser le prénom fourni par le téléservice ?"
      testId="modal-insi_data-firstname-difference-update"
    >
      <div className={styles.insiPatientFirstnameDifferencesContainer}>
        <span className={styles.insiPatientFirstnameValueSource}>Formulaire :</span>
        <span>
          <b>{userInputFirstname}</b>
        </span>
        <span className={styles.insiPatientFirstnameValueSource}>Téléservice :</span>
        <span className={styles.insiPatientFirstnameValue}>
          <b>{insiResponseFirstname.toLowerCase()}</b>
        </span>
      </div>

      <span className={styles.insiPatientFirstnameDifferencesMessage}>
        Le reste du formulaire ne sera pas impacté.
      </span>
    </ValidationModal>
  )
}
